import { isValidNifFormat } from './nif';

/**
 * Validador partilhado de form de morada — espelha o backend
 * `_validate_address_payload` e as `validate()` que existiam duplicadas em
 * `MY/AddressSection.jsx` e `components/AddressEditor.jsx`.
 *
 * Regras:
 *   - Nome, Morada, Localidade, Código Postal: obrigatórios.
 *   - País: obrigatório.
 *   - Para PT (`ID_Pais === 'PRT'`), o Código Postal deve ter formato `NNNN-NNN`.
 *   - NIF (opcional): se preenchido, tem de ser 9 dígitos numéricos.
 *
 * @returns {{ ok: true } | { ok: false, message: string, field?: string }}
 */
export function validateAddressForm(form = {}) {
  for (const [k, lbl] of [
    ['Nome', 'Nome'],
    ['Morada', 'Morada'],
    ['Localidade', 'Localidade'],
    ['CodigoPostal', 'Código Postal'],
  ]) {
    if (!String(form[k] || '').trim()) {
      return { ok: false, message: `Preencha ${lbl}.`, field: k };
    }
  }

  const pais = (form.ID_Pais || '').toString().trim();
  if (!pais) {
    return { ok: false, message: 'Seleccione o país.', field: 'ID_Pais' };
  }

  if (pais === 'PRT' && !/^\d{4}-\d{3}$/.test(String(form.CodigoPostal).trim())) {
    return { ok: false, message: 'Código Postal deve ter o formato NNNN-NNN.', field: 'CodigoPostal' };
  }

  const nif = (form.Nif || form.NIF || '').toString().trim();
  // Só validamos o formato do NIF para Portugal. Outros países (ex.: Espanha)
  // podem ter NIF com letras/formatos diferentes — não validar.
  if (pais === 'PRT' && nif && !isValidNifFormat(nif)) {
    return { ok: false, message: 'NIF deve ter 9 dígitos numéricos.', field: 'Nif' };
  }

  return { ok: true };
}
